const PREVIEW_SIZE = 6;
// These are display preferences only. Availability and reward data come from the server.
const preferredLabels = {
  light: ["300 💎", "1000 💎", "5000 💎", "3 🎴", "10 🎴", "25 🎴"],
  limited: ["3000 💎", "50000 💎", "10 🎴", "50 🎴", "100 🎴", "LIMITED", "10000 💎"],
  mystic: ["7000 💎", "50000 💎", "150000 💎", "35 🎴", "500 🎴", "Mystic", "250 🎴", "100 🎴", "50 🎴", "10000 💎"],
};

/**
 * Keep weak and strong examples without suggesting unavailable prizes.
 * @template {{label: string}} T
 * @param {string} caseId
 * @param {T[]} rewards
 * @returns {T[]}
 */
export function selectShopRewardPreview(caseId, rewards) {
  const unique = [...new Map(rewards.map(reward => [reward.label, reward])).values()];
  const available = new Set(unique.map(reward => reward.label));
  const selected = new Set((preferredLabels[caseId] || []).filter(label => available.has(label)).slice(0, PREVIEW_SIZE));
  // If a special card is unavailable, fill its tile with an existing strong resource prize.
  const remaining = unique.filter(reward => !selected.has(reward.label)).sort((a, b) =>
    (Number.parseInt(b.label, 10) || 0) - (Number.parseInt(a.label, 10) || 0));
  for (const reward of remaining) {
    if (selected.size >= PREVIEW_SIZE) break;
    selected.add(reward.label);
  }
  return unique.filter(reward => selected.has(reward.label));
}
